import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/ruler/pages/CalculatorPage";

export const Route = createFileRoute("/ruler")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/ruler",
      title: m.ruler_meta_title(),
      description: m.ruler_meta_description(),
      toolName: m.ruler_tool_name(),
      faqs: [
        { q: m.ruler_faq_q1(), a: m.ruler_faq_a1() },
        { q: m.ruler_faq_q2(), a: m.ruler_faq_a2() },
        { q: m.ruler_faq_q3(), a: m.ruler_faq_a3() },
        { q: m.ruler_faq_q4(), a: m.ruler_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
